import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const PanelKeyboardRequest = Schema.Union([
  Schema.Struct({ _tag: Schema.Literal("Tab"), id: Schema.String }),
  Schema.Struct({ _tag: Schema.Literal("Panel"), id: Schema.String })
]);
export type PanelKeyboardRequest = typeof PanelKeyboardRequest.Type;
export class PanelKeyboardFocusFailure extends privateDependencyFailure<PanelKeyboardFocusFailure>()("PanelKeyboardFocusFailure", "editor panel keyboard focus") {}
export const panelKeyboardFocusFailure = (cause: unknown) => new PanelKeyboardFocusFailure({ cause: Redacted.make(cause) });
